module.exports = __webpack_public_path__ + "static/media/reports-active.a97407be.svg";